<template>
  <v-container-np class="text-center" :class="Spacings.homePageSectionPadding">
    <v-container-restricted
      style="
        max-width: var(--homepage-max-width) !important ;
        padding: 0px !important;
      "
    >
      <v-row justify="center" no-gutters
        ><UnderlinedHeading :text="$t('homepage.testimonialsTitle')">
        </UnderlinedHeading
      ></v-row>
      <SlideOnIntersectContainer direction="left">
        <v-carousel
          height="400"
          cycle
          :class="Spacings.homePageHeadingMargin"
          continous
          color="primary"
          hide-delimiter-background
        >
          <template v-slot:prev="{ props }">
            <v-icon
              class="d-none d-sm-block"
              size="50"
              color="primary"
              icon="mdi-chevron-left"
              @click="props.onClick"
            ></v-icon>
          </template>
          <template v-slot:next="{ props }">
            <v-icon
              class="d-none d-sm-block"
              size="50"
              color="primary"
              icon="mdi-chevron-right"
              @click="props.onClick"
            ></v-icon>
          </template>
          <v-carousel-item v-for="testimonial in testimonials">
            <v-container
              class="d-flex align-center justify-center flex-column px-sm-16 py-0"
              style="height: 350px"
            >
              <p class="text-h6 text-truncate w-100">
                {{ testimonial.username }}
              </p>
              <v-avatar size="80" class="my-2">
                <Image :cover="true" :src="testimonial.userImageUrl"></Image>
              </v-avatar>
              <v-rating
                readonly
                :model-value="testimonial.stars"
                class="ma-2"
                color="secondary"
                item-label-position="top"
              ></v-rating>
              <p class="text-subtitle-1 limit-to-5-lines">
                {{ testimonial.review }}
              </p>
              <p class="text-caption my-2">
                {{ formatDateToEnglish(testimonial.date) }}
              </p>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </SlideOnIntersectContainer>
    </v-container-restricted>
  </v-container-np>
</template>
<script setup lang="ts">
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";
import { formatDateToEnglish } from "~/core/helpers/date_functions";
import type { testimonial } from "~/core/interfaces/home_page.interfaces";
import SlideOnIntersectContainer from "../common/animation/SlideOnIntersectContainer.vue";
const testimonials: testimonial[] = [
  {
    username: "Awais Mazhar",
    stars: 5,
    userImageUrl:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=400",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. Nulla dui nisi, accumsan ac est at, posuere feugiat mi. Nullam cursus enim nec justo vestibulum, quis pellentesque dui porttitor.",
    date: new Date(2024, 8, 20),
  },
  {
    username: "Awais Mazhar",
    stars: 4,
    userImageUrl:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=400",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. Nulla dui nisi, accumsan ac est at, posuere feugiat mi. Nullam cursus enim nec justo vestibulum, quis pellentesque dui porttitor.",
    date: new Date(2024, 8, 20),
  },
  {
    username: "Awais Mazhar",
    stars: 5,
    userImageUrl:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=400",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. Nulla dui nisi, accumsan ac est at, posuere feugiat mi. Nullam cursus enim nec justo vestibulum, quis pellentesque dui porttitor.",
    date: new Date(2024, 8, 20),
  },
  {
    username: "Awais Mazhar",
    stars: 4,
    userImageUrl:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=400",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ex augue, malesuada malesuada justo non, laoreet dapibus nunc.",
    date: new Date(2024, 5, 24),
  },
  {
    username: "Awais Mazhar",
    stars: 4,
    userImageUrl:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=400",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In exaugue, malesuada malesuada justo non, laoreet dapibus nunc. Fusce neque tortor, condimentum at malesuada eget, semper ac lectus. Nulla dui nisi, accumsan ac est at, posuere feugiat mi. Nullam cursus enim nec justo vestibulum, quis pellentesque dui porttitor.",
    date: new Date(2024, 8, 20),
  },
];
</script>
<style scoped>
.limit-to-5-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  line-height: 22px;
  overflow: hidden;
  max-height: calc(5 * 22px);
}
</style>
